import axios from "axios";
import MockupAxios from "../utility/mockups/MockupAxios";
import moment from "moment";

const MOCKUP = false;
const baseURL = process.env.REACT_APP_SERVER_URL;
let api = MOCKUP ? new MockupAxios() : axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const localUser = localStorage.getItem("@satify-admin/user");
  const localCompany = localStorage.getItem("@satify-admin/company");
  const user = localUser ? JSON.parse(localUser) : null;
  const company = localCompany ? JSON.parse(localCompany) : null;

  if (user && user.token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${user.token}`,
      Role: company?.role?._id,
      Company: company?.company?._id,
    };
  }

  return config;
});

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const {response} = error;
  let message = Array.isArray(response.data?.message) ? response.data?.message.join(", ") : response.data?.message;
  if(message === 'Network Error') message = "Consulta indisponível no momento";
  if(message){ throw new Error(message); }
  throw error;
});

export {api};